// src/components/Admin/Dashboard.jsx
import { useState } from 'react';
import ManageColleges from './ManageColleges';
import ManageCategories from './ManageCategories';
import ManageMatches from './ManageMatches';
import ManageEvents from './ManageEvents';

export default function Dashboard() {
  const [tab, setTab] = useState('colleges');

  const tabs = [
    { id: 'colleges', label: 'Manage Colleges', component: <ManageColleges /> },
    { id: 'categories', label: 'Manage Categories ', component: <ManageCategories /> },
    { id: 'matches', label: 'Matches & Winners', component: <ManageMatches /> },
    { id: 'events', label: 'Manage Events', component: <ManageEvents /> },
  ];

  const currentTab = tabs.find(t => t.id === tab);

  return (
    <div>
      <h1 className="text-3xl font-bold text-primary mb-6">Admin Dashboard</h1>

      {/* Tab Navigation */}
      <div className="flex flex-wrap gap-2 mb-8 border-b pb-2">
        {tabs.map(t => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`px-4 py-2 rounded-t-lg font-medium transition ${
              tab === t.id
                ? 'bg-primary text-white shadow'
                : 'bg-gray-100 hover:bg-gray-200'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="bg-white p-6 rounded-lg shadow">
        {currentTab.component}
      </div>
    </div>
  );
}